<template>
  <div class="vue-admin-beautiful-wrapper" :class="classObj">
    <component
      :is="'vab-layout-' + theme.layout"
      :collapse="collapse"
      :device="device"
      :fixed-header="theme.fixedHeader"
      :show-tabs="theme.showTabs"
    />
    <el-backtop target="#app" />
    <!--  主题组件放到layouts下防止主题切换，导致主题组件重新加载 -->
    <vab-theme-drawer />
    <vab-theme-setting />
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed, onBeforeMount, onBeforeUnmount, watch, ref } from 'vue'
import { useRoute } from 'vue-router'
export default {
  name: 'Layouts',
  setup() {
    const store = useStore()
    const device = computed(() => store.getters['settings/device'])
    // const collapse = computed(() => store.getters['settings/collapse'])
    const collapse = ref(false)
    const theme = computed(() => store.getters['settings/theme'])
    const toggleDevice = (device) =>
      store.dispatch('settings/toggleDevice', device)
    const foldSideBar = () => store.dispatch('settings/foldSideBar')
    const openSideBar = () => store.dispatch('settings/openSideBar')
    // 加载路由
    // const routes = computed(() => store.getters['routes/routes'])
    //获取当前路由
    const route = useRoute()
    const currentPath = computed(() => route.matched[0])
    console.log('currentPath---------->', currentPath)
    const showHideRoute = (routes, path) => {
      routes.forEach((route) => {
        if (route.fullPath.indexOf(path) !== -1) {
          route.hidden = false
        }
      })
    }
    watch(
      () => route.path,
      async() => {
        const isCollapse = route.meta.collapse
        if (!isCollapse) {
          collapse.value = store.getters['settings/collapse']
          // collapse.value = false
          // await store.dispatch('settings/foldSideBar', false)
        } else {
          collapse.value = true
          // await store.dispatch('settings/foldSideBar', true)
        }
        //控制路由的显示和掩藏
        console.log('route.path', route.name)
        // const isHide = route.meta.isHide
        // if (isHide) {
        //   route.meta.isHide = false
        //   route.hidden = false
        // }
        // await store.dispatch('routes/setRoutes', authentication)
        const path = route.path
        const parentPath = path.split('/')[1]
        //获取所有被显示的routes
        const routes = computed(() => store.getters['routes/routes'])
        //获取appRoutes
        // const appRoutes = computed(() => store.getters['routes/appRoutes'])
        // console.log(appRoutes.value)
        // //获取dynamicRoutes
        // const dynamicRoutes = computed(() => store.getters['routes/dynamicRoutes'])
        // //获取初始化的routes
        // const initRoutes = computed(() => store.getters['routes/initRoutes'])
        // //1.查找当前路由是否存在动态路由中
        // const inAppRoutes = appRoutes.value.find(item=>item.path.indexOf(parentPath) > -1)
        // if(inAppRoutes) {
        //   console.log('存在appRoutes中',parentPath)
        //   //2.存在则判断是否已经在routes中
        //   const inDynamicRoutes = dynamicRoutes.value.find(item=>item.path.indexOf(parentPath) > -1)
        //   if(inDynamicRoutes) {
        //     console.log('inDynamicRoutes',parentPath)
        //   }else {
        //     console.log('不存在inDynamicRoutes',parentPath)
        //     //把路由加入到inDynamicRoutes中
        //     dynamicRoutes.value.push(inDynamicRoutes)
        //     const newInitRoutes = [...initRoutes.value,dynamicRoutes.value]
        //     store.dispatch('routes/setDynamicRoutes', dynamicRoutes)
        //     store.dispatch('routes/setRoutes', newInitRoutes)
        //   }
        // }
        //查找appRoutes中是否存在
        //找到匹配路由
        // showHideRoute(routes.value, parentPath)
        // store.dispatch('routes/setRoutes', routes)
        console.log('修改后的routers', routes)
      },
      {
        immediate: true,
      }
    )
    let isMobile = false
    let oldLayout = ''

    const classObj = computed(() => {
      return {
        mobile: device.value === 'mobile',
      }
    })
    const handleLayouts = () => {
      const isMobileTemp = document.body.getBoundingClientRect().width - 1 < 992
      if (isMobileTemp !== isMobile) {
        if (isMobileTemp) {
          oldLayout = theme.value.layout
          foldSideBar()
        } else openSideBar()
        theme.value.layout = isMobileTemp ? 'vertical' : oldLayout
        toggleDevice(isMobileTemp ? 'mobile' : 'desktop')
        isMobile = isMobileTemp
      }
    }

    onBeforeMount(() => {
      oldLayout = theme.value.layout
      window.addEventListener('resize', handleLayouts)
      handleLayouts()
    })
    onBeforeUnmount(() => {
      if (isMobile) theme.value.layout = oldLayout
      window.removeEventListener('resize', handleLayouts)
    })

    return {
      theme,
      device,
      classObj,
      collapse,
      foldSideBar,
      openSideBar,
      toggleDevice,
      showHideRoute,
    }
  },
}
</script>

<style lang="scss" scoped>
.vue-admin-beautiful-wrapper {
  position: relative;
  width: 100%;
  height: 100%;

  [class*='vab-layout-'] {
    position: relative;

    :deep() {
      .vab-layout-header {
        // box-shadow: $base-box-shadow;
      }
    }

    &.fixed {
      padding-top: $base-nav-height + $base-tabs-height;
    }

    &.fixed.no-tabs-bar {
      padding-top: $base-nav-height;
    }
  }

  :deep() {
    .fixed-header {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: $base-z-index - 1;
      width: 100%;
    }

    .vab-main {
      position: relative;
      width: auto;
      min-height: 100%;
      margin-left: $base-left-menu-width;

      &.is-collapse-main {
        margin-left: $base-left-menu-width-min;

        .fixed-header {
          left: $base-left-menu-width-min;
          width: calc(100% - #{$base-left-menu-width-min});
        }
      }
    }
  }

  /* 手机端开始 */
  &.mobile {
    :deep() {
      .vab-layout-vertical {
        .el-scrollbar.vab-side-bar.is-collapse {
          width: 0;
        }

        .vab-main {
          .fixed-header {
            left: 0;
            width: 100%;
          }

          width: 100%;
          margin-left: 0;
        }
      }

      /* 隐藏分页和页码跳转 */
      .el-pager,
      .el-pagination__jump {
        display: none;
      }
    }
  }

  /* 手机端结束 */
}
</style>
